import { LucideExternalLink, LucidePaperclip } from 'lucide-react'
import type { Listing } from '~/models'
import { ActivityRelatedType, ActivityType } from '~/models'
import { createActivity } from '~/query'

type ListingFilesProps = {
  listing: Listing
}

export default function ListingFiles({ listing }: ListingFilesProps) {
  if ((listing.files || []).length === 0) {
    return null
  }

  return (
    <div className="sm:col-span-2">
      <div className="mt-2 text-base text-foreground">
        <ul role="list" className="divide-y divide-border rounded-md border">
          {listing.files!.map((file, index) => {
            return (
              <li key={index}>
                <a
                  href={file.url}
                  target="_blank"
                  className="flex items-center justify-between py-3 pl-3 pr-4 text-base hover:bg-muted"
                  onClick={() =>
                    createActivity({
                      type: ActivityType.download,
                      relatedType: ActivityRelatedType.listing,
                      relatedId: listing.id,
                      meta: { file },
                    })
                  }>
                  <div className="flex w-0 flex-1 items-center">
                    <LucidePaperclip
                      className="h-5 w-5 flex-shrink-0 text-muted-foreground"
                      aria-hidden="true"
                    />
                    <span className="ml-4 w-0 flex-1 truncate">
                      {file.title || 'Listing Brochure'}
                    </span>
                  </div>
                  <div className="ml-4 flex-shrink-0">
                    <LucideExternalLink className="h-5 w-5 print:hidden" />
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
